export default __webpack_public_path__ + "static/media/neet_audiprep.8a48fb1a.svg";